import removeTableFromStore from '../actions/store-factory/removeTableFromStore';
import { removeSearchTableFromStore } from 'owa-mail-search';
import { createLazyOrchestrator } from 'owa-bundling';

export default createLazyOrchestrator(
    removeSearchTableFromStore,
    'clone_removeSearchTableFromStore',
    actionMessage => {
        removeTableFromStore(actionMessage.tableViewId);
    }
);
